<template>
  <div id="nav">
    {{ this.$route.meta.pageTitle }}
    <div v-show="Boolean($route.meta.backMenu)" @click="$router.push({path: '/'})" class="menuHome"></div>
    <!-- <div class="menuBox">
      <span class="menuTitle" @mouseenter="projectShow = true" @mouseleave="projectShow = true">
        设计进度管理
        <img :src="require('@/assets/img/ToBottom.png')" style="width: 0.2rem;vertical-align: middle;" />
      </span>
      <div v-show="projectShow" class="projectList">
        <ul class="pageLists">
          <li v-for="(item,index) in $router.options.routes" :key="index" :class="$route.path == item.path ? 'isChose' : ''" @click="go(item.pathName)">
            {{item.meta.pageTitle}}
          </li>
        </ul>
      </div>
    </div> -->
    <div v-show="$route.path != '/'" @click="$router.push({path: '/'})" class="menuHome"></div>
    <div v-show="$route.path != '/'" @mouseenter="projectShow = true" @mouseleave="projectShow = false" @click="projectShow = !projectShow" class="menu">
      <div v-show="projectShow" class="projectList">
        <ul class="pageLists">
          <li v-for="(item,index) in menuLists" :key="index" :class="$route.path == item.path ? 'isChose' : ''" @click="go(item.name)">
            {{item.meta.pageTitle}}
          </li>
        </ul>
      </div>
    </div>
    <!-- <PageTab /> -->
    <span class="timeSpan">
      <span>{{nowTime}}</span>
      <i
        :style="{
          'font-size': '0.24rem',
          top: '0.36rem',
          right: '-0.03rem',
          cursor: 'pointer',
          color: '#01c4f7',
          'margin-left': '0.2rem'
        }"
        @click="Logout()"
        class="iconfont icon-tuichu"></i>
    </span>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
// import PageTab from './PageTab'
export default {
  name: 'NavTitle',
  computed: {
    menuLists: {
      get(){
        return this.$router.getRoutes().filter(item => item.path != '/' && item.path != '');
      },
      set(){}
    },
  },
  components: {
    // PageTab
  },
  data(){
    return{
      projectShow: false,
      timer: null,
      timeDatas: null,
      nowTime: '',
      cacheData: null
    }
  },
  props: {
    menuShow:{
      type: Boolean,
      default: true
    }
  },
  watch: {
    $route: {
      handler(){
        this.fn();
      },
      immediate: true
    }
  },
  methods:{
    ...mapActions(['Logout']),
    fn(){
      this.timer = requestAnimationFrame(this.step)
    },
    step(){
      this.nowTime = new Date().toLocaleString();
      this.timer = requestAnimationFrame(this.step);
    },
    go(path){
      if(path != this.$route.name)
        this.$router.push({name: path});
    }
  }
}
</script>
<style lang="less" scoped>
@import '../assets/font/iconfont.css';
.menuHome{
  position: absolute;
  z-index: 999;
  top: 43%;
  left: 0.4rem;
  width: 0.3rem;
  height: 0.23rem;
  padding-bottom: 0.07rem;
  background: url('../assets/img/home.svg') no-repeat;
  background-size: cover;
  cursor: pointer;
  &:first-child{
    background: url('../assets/img/back.svg') no-repeat;
    background-size: cover;
  }
}
.menuBox{
  position: absolute;
  z-index: 999;
  top: 43%;
  left: 1.5rem;
  .menuTitle{
    display: block;
    color: #fff;
    font-size: 0.16rem;
    padding: 0 0.2rem;
    height: 0.3rem;
    line-height: 0.3rem;
    cursor: pointer;
    border: 1px solid #01c4f7;
    background: #052666;
    border-radius: 0.1rem;
  }
  .projectList{
    position: absolute;
    top: 0.55rem;
    right: -0.7rem;
    width: 2rem;
    height: auto;
    background: #052666;
    border: 2px solid #006CC8;
    border-top: none;
    border-radius: 0.1rem;
    font-size: 0.14rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FEFEFE;
    padding: 0.2rem 0.09rem 0.2rem 0.09rem;
    &::before{
      content: '';
      position: absolute;
      top: -0.2rem;
      left: 50%;
      margin-left: -0.1rem;
      border-bottom: 0.2rem solid #052666;
      border-left: 0.2rem solid transparent;
      border-right: 0.2rem solid transparent;
    }
    .pageLists{
      width: 100%;
      list-style: none;
      text-align: center;
      .isChose{
        color:#19C8FD;
      }
      li{
        margin-top: 0.14rem;
        cursor: pointer;
        &:hover{
          color:#19C8FD;
        }
      }
      li:first-child{
        margin-top: 0;
      }
    }
  }
}

#nav {
  width: 100%;
  height: 7.78%;
  background-image: url('../assets/img/header.png');
  background-size: 100% 100%;
  font-size: 0.3rem;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #01c4f7;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .timeSpan{
    display: flex;
    align-items: center;
    font-size: 0.16rem;
    position: absolute;
    top: 0.3rem;
    right: 0rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #02D9FD;
  }
  .menu{
    position: absolute;
    padding-right: 0.3rem;
    z-index: 999;
    top: 50%;
    left: 0.8rem;
    width: 0.3rem;
    height: 0.23rem;
    background: url('../assets/img/menuIcon.png') no-repeat;
    background-size: auto 100%;
    cursor: pointer;
    .projectList{
      position: absolute;
      top: 0rem;
      left: 0.4rem;
      width: 2rem;
      height: auto;
      background: #052666;
      border: 2px solid #006CC8;
      border-radius: 0.1rem;
      font-size: 0.14rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FEFEFE;
      padding: 0.2rem 0.09rem 0.2rem 0.09rem;
      // border-top-left-radius: 0;
      &::before{
        content:'';
        display: block;
        width: 0;
        height:0;
        position: absolute;
        top:0.01rem;
        left: -0.1rem;
        border-right: 0.1rem solid #006CC8;
        border-top:0.1rem solid transparent;
        border-bottom:0.3rem solid transparent;
      }
      &::after{
        content: '';
        display: block;
        width: 0;
        height: 0;
        position: absolute;
        top: 0.01rem;
        left: -0.07rem;
        border-right: 0.1rem solid #052666;
        border-top:0.1rem solid transparent;
        border-bottom:0.3rem solid transparent;
      }
      .topHeader{
        padding-left: 0.26rem;
      }
      .bannerHeader{
        width: 100%;
        height: 0.3rem;
        background: #0C1648;
        padding-left: 0.55rem;
        line-height: 0.3rem;
        box-sizing: border-box;
      }
      .pageLists{
        width: 100%;
        list-style: none;
        text-align: center;
        .isChose{
          color:#19C8FD;
        }
        li{
          margin-top: 0.14rem;
          &:hover{
            color:#19C8FD;
          }
        }
        li:first-child{
          margin-top: 0;
        }
      }
    }
  }
}
</style>
